import { useApi } from '@deputyapp/webapp-sdk';

export interface FetchV2SubordinateCheckResponse {
  success: boolean;
  isSubordinate: boolean;
}

export async function fetchV2SubordinateCheck(
  employeeId: number
): Promise<FetchV2SubordinateCheckResponse> {
  if (!employeeId || employeeId <= 0) {
    throw new Error('Valid employee ID is required');
  }

  try {
    const { v2 } = useApi();

    const { data } = await v2.get<FetchV2SubordinateCheckResponse>(
      '/api/employee/v2/subordinate-check',
      { params: { 'employee-id': employeeId } }
    );

    return { success: data.success, isSubordinate: data.isSubordinate };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error occurred';
    throw new Error(`Failed to check subordinate status: ${errorMessage}`);
  }
}
